import { point as turfPoint } from '@turf/helpers';
import distance from '@turf/distance';
import I18N from '@leverege/i18n';
import ModelUtil from '@leverege/model-util';
import { Attributes } from '@leverege/ui-attributes';
const TYPE = 'historyAccumulator.nearby';
const {
  t
} = I18N.ns('molten.dataViewers.map.historyAccumulator');
function create() {
  return {
    type: TYPE,
    units: 'meters',
    clusterDistance: 20
  };
}
function pointsFor(model, inPoints, context) {
  const {
    relationship: {
      blueprint
    },
    attributeName
  } = context;
  const {
    units = 'meters',
    clusterDistance = 20
  } = model;
  const geoPositionAttr = Attributes.getAttribute(attributeName, blueprint.historyType);
  const outPoints = [];
  const areNearby = (p1, p2) => {
    if (!p1 || !p2) {
      return false;
    }
    const p1gp = geoPositionAttr.get(p1.data, context);
    const p2gp = geoPositionAttr.get(p2.data, context);
    if (p1gp && p2gp) {
      const point1 = turfPoint([p1gp.lon, p1gp.lat]);
      const point2 = turfPoint([p2gp.lon, p2gp.lat]);
      const dist = distance(point1, point2, {
        units
      });
      if (dist < clusterDistance) {
        return true;
      }
    }
    return false;
  };
  let point, nextPoint;
  for (let i = 0; i < inPoints.length; i++) {
    point = inPoints[i];
    nextPoint = inPoints[i + 1];
    const returnPoint = {
      accum: point,
      raw: [point]
    };
    let whileCount = 0;
    do {
      // If the current point and next point are nearby, cluster them
      // If the next point is the last point, don't cluster so we can complete the history line up to current
      if (areNearby(point, nextPoint) && i < inPoints.length - 1) {
        returnPoint.raw.push(nextPoint);
        nextPoint = inPoints[++i];
      } else {
        if (whileCount > 0) {
          --i;
        }
        break;
      }
      ++whileCount;
      // eslint-disable-next-line no-constant-condition
    } while (true);
    outPoints.push(returnPoint);
  }
  return outPoints;
}
export default {
  TYPE,
  create,
  get name() {
    return t('nearby', 'Nearby');
  },
  pointsFor,
  ...ModelUtil.createAllValue('units'),
  ...ModelUtil.createAllValue('clusterDistance')
};